export const SHORT_VIDEO_UPLOAD_LIMITS = {
  minDurationSeconds: 3,
  maxDurationSeconds: 60,
  maxSizeBytes: 200 * 1024 * 1024,
};

export const IMAGE_UPLOAD_MIME_TYPES = ["image/jpeg", "image/png", "image/webp"];
export const IMAGE_UPLOAD_EXTENSIONS = [".jpg", ".jpeg", ".png", ".webp"];
export const IMAGE_UPLOAD_ACCEPT = {
  "image/jpeg": [".jpg", ".jpeg"],
  "image/png": [".png"],
  "image/webp": [".webp"],
};
export const IMAGE_UPLOAD_ACCEPT_STRING =
  "image/jpeg,image/png,image/webp,.jpg,.jpeg,.png,.webp";

export const SHORT_VIDEO_UPLOAD_MIME_TYPES = [
  "video/mp4",
  "video/webm",
  "video/quicktime",
];
export const SHORT_VIDEO_UPLOAD_EXTENSIONS = [".mp4", ".webm", ".mov"];
export const SHORT_VIDEO_UPLOAD_ACCEPT = {
  "video/mp4": [".mp4"],
  "video/webm": [".webm"],
  "video/quicktime": [".mov"],
};
export const SHORT_VIDEO_UPLOAD_ACCEPT_STRING =
  "video/mp4,video/webm,video/quicktime,.mp4,.webm,.mov";
export const LIVE_PHOTO_UPLOAD_ACCEPT = {
  ...IMAGE_UPLOAD_ACCEPT,
  "video/quicktime": [".mov"],
};
export const LIVE_PHOTO_UPLOAD_ACCEPT_STRING = `${IMAGE_UPLOAD_ACCEPT_STRING},video/quicktime,.mov`;

export const SHORT_VIDEO_UPLOAD_MESSAGES = {
  size: "파일 용량은 최대 200MB까지 지원합니다.",
  duration: "영상은 3초 이상, 60초 이하로 업로드할 수 있어요.",
  invalid: "영상 정보를 읽을 수 없습니다. 다른 파일을 선택해주세요.",
  format: "mp4, webm, mov 형식의 영상만 업로드할 수 있어요.",
  ratio: "세로 영상 9:16 비율을 권장해요.",
};
